/* eslint-disable @typescript-eslint/no-explicit-any */
import { GenericObject } from "@mongez/reinforcements";

export const URLS = {
  maintenance: "/maintenance",
  home: "/",
  compare: "/compare",
  contactUs: "/contact-us",
  buyingGuide: "/buying-guide",
  business: "/business",
  cart: "/cart",
  trackOrder: "/track-order",
  subscribe: "/subscribe",
  inspections: "/inspections",
  checkout: {
    root: "/checkout",
    viewSuccessCheckout: (orderId: number) =>
      `/checkout/payment/success/${orderId}`,
    viewTrackOrder: (orderId: number) => `/checkout/track-order/${orderId}`,
    proccessPayment: "/checkout/payment/process",
    successPayment: "/payment-success",
  },

  /**
   * Pages rendered inside the AI chat widget's iframe.
   *
   * They share the loaders, actions and hooks of their full-site counterparts
   * and differ only in presentation, but need their own URLs so the widget
   * chrome (header, footer, navigator) can be dropped and so framing can be
   * allowed for these paths alone.
   */
  embed: {
    checkout: {
      root: "/embed/checkout",
      viewSuccessCheckout: (orderId: number) =>
        `/embed/checkout/success/${orderId}`,
      proccessPayment: "/embed/checkout/payment/process",
    },
  },
  search: "/search",
  notifications: "/notifications",
  calculateBtu: "/calculate-btu",

  // auth
  auth: {
    login: "/login",
    loginOTP: "/login-otp",
    register: "/register",
    forgotPassword: "/forgot-password",
    resetPassword: "/reset-password",
    verifyEmail: "/verify-email",
    googleLogin: "/google-login",
    verifyPhone: "/verify-phone",
  },

  // shop
  shop: {
    root: "/shop",
    brandsLayout: "/brand",
    categoriesLayout: "category",
    productsLayout: "/product",
    filterByLayout: "/filter-by",
    spareParts: "/shop/spare-parts",
    btu: "/filter-by/btu",
    btuFiltered: (id: number) => `${URLS.shop.btu}/${id}`,
    ton: "/filter-by/ton",
    tonFiltered: (id: number) => `${URLS.shop.ton}/${id}`,
    roomSize: "/filter-by/room-area",
    roomSizeFiltered: (id: number) => `${URLS.shop.roomSize}/${id}`,
    viewCategory: (categorySlug: string) => `/category/${categorySlug}`,
    viewBrand: (brandSlug: string) => `/brand/${brandSlug}`,
    viewProduct: (productSlug: string) => `/product/${productSlug}`,
    checkout: (product: GenericObject) =>
      `/shop/products/${product.slug}/${product.id}/checkout`,
    offers: "/offers/active-for-offer",
    saudiNationalDay: "/offers/saudi-national-day",
    viewOffer: (slug: string) => `/offers/${slug}`,
  },

  // about-us pages
  aboutUs: {
    root: "/about-us",
    aboutUsSenaat: "/about-us/senaat",
    aboutUsAirConditioning: "/about-us/zamil-air-conditioners",
    aboutUsViewAndCore: "/about-us/vision-mission-core-values",
    aboutUsIkhtebar: "/about-us/testing-ikhtebar",
    aboutUsSynexis: "/about-us/synexis",
    aboutUsSamaya: "/about-us/samaya",
    aboutUsSamsung: "/about-us/samsung",
  },

  // profile
  profile: {
    root: "/profile",
    updateProfile: "/profile/update-profile",
    changePassword: "/profile/change-password",
    ordersHistory: {
      root: "/profile/orders-history",
      order: (orderId: number | string) => `/profile/orders-history/${orderId}`,
      ratingOrder: "/profile/orders-history/rating-order",
    },
    devices: "/profile/devices",
    addresses: "/profile/addresses",
    wishlist: "/profile/wishlist",
    logout: "/profile/logout",
  },

  // services
  services: {
    residential: {
      newRequest: "/residential/new-request",
      followUpRequest: "/residential/follow-up",
    },
    industrial: {
      newRequest: "/industrial/new-request",
      followUpRequest: "/industrial/follow-up",
    },
  },

  // blog
  blog: {
    root: "/blog",
    post: (post: GenericObject) => `/blog/${post.slug}`,
    category: (category: GenericObject) => `/blog/category/${category.slug}`,
    author: (id: number) => `/blog/authors/${id}`,
  },

  // informative pages
  informativePages: {
    contactUs: "/contact-us",
    privacyPolicy: "/privacy-policy",
    termsAndConditions: "/terms-conditions",
    faqs: "/faq",
  },
};
